<section class="header">
  <iframe
    class="bg-video"
    [src]="videoUrl"
    title="YouTube background video"
    frameborder="0"
    allow="autoplay"
  ></iframe>

  <div class="my-container">
    <div class="row header-content">
      <div class="d-md-none col-12">
        <img class="w-100" src="assets/light-background-header.png" alt="" />
      </div>

      <div class="col-sm-12 col-md-6 main-block">
        <p>{{ "main.header.subtitle" | translate }}</p>
        <h1>{{ "main.header.title" | translate }}</h1>

        <div class="main-content">
          <p>{{ "main.header.description" | translate }}</p>
          <button (click)="goTo('contacts')">
            {{ "main.header.btn-contact" | translate }}
          </button>
        </div>
      </div>

      <div class="d-none d-md-block col-6">
        <img class="w-100" src="assets/light-background-header.png" alt="" />
      </div>
    </div>
  </div>
</section>
